import './form_label_view.js.coffee'
class Monitoring.Views.EditLabelView extends Monitoring.Views.FormLabelView

  events: =>
    return _.extend({}, Monitoring.Views.FormLabelView.prototype.events, {
      'click #btn-delete': 'onDelete'
    })

  initialize: (@options = {}) ->
    super(@options)
    @formName = 'Edit'

  render: ->
    super
    @$el.find('#label-name').attr("disabled", "disabled"); # label's name Cannot be changed!

  onDelete: (event) =>
    event.preventDefault()

    if @options.save
      @label.destroy(
        success: (label) =>
          @labels.remove(label, true)
      )
    else
      @labels.remove(@label, true)

  _getKeywords: ->
    return @label.keywords_attributes
